import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <section className="py-12 bg-red-900/20 border-y border-red-500/20 relative overflow-hidden" data-id="element-191">
      <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 via-transparent to-red-500/5" data-id="element-192"></div>

      <div className="px-5 relative z-10" data-id="element-193">
        <motion.div className="text-center" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-194">
          <h2 className="text-2xl font-bold text-white font-heading mb-3 leading-tight" data-id="element-195">
            PROMOCIÓN POR
            <br data-id="element-196" />
            TIEMPO LIMITADO
          </h2>
          <p className="text-white/80 text-sm mb-6 leading-relaxed" data-id="element-197">
            Precio promocional disponible por tiempo limitado. Una vez
            finalizada vuelve al valor normal.
          </p>

          {/* Timer */}
          <div className="flex justify-center gap-3 mb-8" data-id="element-198">
            {[{
            label: 'HORAS',
            value: timeLeft.hours
          }, {
            label: 'MIN',
            value: timeLeft.minutes
          }, {
            label: 'SEG',
            value: timeLeft.seconds
          }].map((item, index) => <div key={index} className="flex flex-col items-center" data-id="element-199">
                <div className="bg-background/80 border border-red-500/30 w-16 h-16 rounded-xl flex items-center justify-center mb-1.5 shadow-[0_0_15px_rgba(220,38,38,0.2)]" data-id="element-200">
                  <span className="text-2xl font-bold text-white font-mono" data-id="element-201">
                    {formatTime(item.value)}
                  </span>
                </div>
                <span className="text-[10px] text-white/60 font-bold tracking-wider" data-id="element-202">
                  {item.label}
                </span>
              </div>)}
          </div>

          {/* Progress Bar */}
          <div data-id="element-203">
            <div className="flex justify-between text-xs font-bold mb-2" data-id="element-204">
              <span className="text-red-400" data-id="element-205">Cupos promocionales</span>
              <span className="text-white" data-id="element-206">80% reservado</span>
            </div>
            <div className="h-2.5 w-full bg-background rounded-full overflow-hidden border border-border/50" data-id="element-207">
              <motion.div className="h-full bg-gradient-to-r from-red-600 to-red-400 rounded-full relative" initial={{
              width: 0
            }} whileInView={{
              width: '80%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} data-id="element-208">
                <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.15)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.15)_50%,rgba(255,255,255,0.15)_75%,transparent_75%,transparent)] bg-[length:1rem_1rem] animate-[progress_1s_linear_infinite]" data-id="element-209"></div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
      <style data-id="element-210">{`
        @keyframes progress {
          0% { background-position: 1rem 0; }
          100% { background-position: 0 0; }
        }
      `}</style>
    </section>;
}